<template>
    <div class="seoulmini_status_wrap seoulmini_map" v-show="showSeoulmap && selectedSubMenus[0] !== 'mediumMosq'" :style="setRainfallLegendPosition() === 'rain'? 'top: 140px;' : 'top: 94px;'">
        <p class="box_title">{{ seoulmapTitle }}</p>
        <p class="box_date">(서울시 홈페이지 기준)</p>
        <div class="map_area" style="width: 100%; height: 100%" id="simple-map" ref="simple-map"></div>
        <div class="map_legend_bt_close"><a href="javascript: void(0);" @click.prevent="closeShowSeoulmap()">닫기</a></div>

        <div class="c_tab" v-show="selectedTopMenu === 'Air'">
            <a :class="[seoulMapMenu === 'pm10' ? 'on' : 'off']" href="javascript: void(0);" @click.prevent="setSeoulMapMenu('pm10')">미세먼지</a>
            <a :class="[seoulMapMenu === 'pm25' ? 'on' : 'off']" href="javascript: void(0);" @click.prevent="setSeoulMapMenu('pm25')">초미세먼지</a>
            <a :class="[seoulMapMenu === 'rainfall' ? 'on' : 'off']" href="javascript: void(0);" @click.prevent="setSeoulMapMenu('rainfall')">강우량</a>
        </div>
    </div>
</template>

<script>
import {$_WC, $_TYPE} from '@/confs/common.const.js';
import GripGeoJsonSimpleMap from "@/libs/grip.simplemap.js";
import simpleMapMixins from '@/stores/simple.map.mixin';
import gripUtil from "@/libs/grip.util";
import {mapGetters} from "vuex";

export default {
    props: {
        wrapClass: {
            type: String,
            default: 'simple_map_wrap'
        },
        innerClass: {
            type: String,
            default: 'simple_map'
        },
        gejsonUrl: {
            type: String,
            required: false,
            default: $_WC.assets + 'geojson/adarea/11/sig.json',
        },
        keyProp: {
            type: String,
            default: 'adm_code',
        },
        nameProp: {
            type: String,
            default: 'name',
        },
        center: {
            type: Array,
            required: false,
        },
        mapScale: {
            type: Number,
            default: 1.0
        }
    },
    computed: {
        ...mapGetters({
            simpleMap: 'getSimpleMap',
            showSeoulmap: 'getShowSeoulmap',
            selectedTopMenu: 'getSelectedTopMenu',
            seoulMapMenu: 'getSeoulMapMenu',
            topMenuList: 'getTopMenuList',
            selectedSubMenus: 'getSelectedSubMenus',
        }),
        topMenuMap(){
            return gripUtil.toDict(this.topMenuList, 'code');
        },
        seoulmapTitle(){
            let title = '';
            if(this.selectedTopMenu == '') {
                title = '';
            } else {
                title = this.topMenuMap[this.selectedTopMenu].seoulMapTitle;
            }
            return title;
        },
    },
    watch: {
        showSeoulmap: {
            immediate: false,
            handler: function (newVal, oldVal) {
                if(newVal) {
                    this.$nextTick(() => {
                        this.drawSimplemap();
                    });
                }
            }
        },
    },
    methods: {
        drawSimplemap(){
            if(typeof this.simpleMap === $_TYPE.UNDEF && this.showSeoulmap) {
                let gripSimpleMap = new GripGeoJsonSimpleMap("simple-map");
                gripSimpleMap.setGeoJsonUrl(this.gejsonUrl)
                    .setKeyPropNm(this.nameProp)
                    .setNamePropNm(this.nameProp)
                    .setMapScale(this.mapScale)
                    .setPathOpacity(0.55)
                    .setPathStrokeWidth(2)
                    .setPathClickHandler((areaCode, areaName, isText) => {
                    })
                    .setMapDrawCompletedHandler(() => {
                        this.$eventBus.$emit("SimpleMap::completed-simple-map-draw", gripSimpleMap);
                    });
                gripSimpleMap.setCenter([126.9797916, 37.5750615]);
                gripSimpleMap.drawMap();
            }
        },
        closeShowSeoulmap(){
            this.$store.dispatch('SET_SHOW_SEOULMAP', false);
        },
        setSeoulMapMenu(val) {
            this.$store.dispatch('SET_SEOUL_MAP_MENU', val);
        },
        setRainfallLegendPosition() {
            let selectedSubMenu = this.selectedSubMenus[0];
            return selectedSubMenu;
        },
    },
    mixins: [simpleMapMixins],
}
</script>
